import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser, selectEmailVerificationPending } from '../../store/user/user.selector.js';
import { selectDisplayedGradient, selectGradientData } from '../../store/system/system.selector.js';
import { selectTeamIndex } from '../../store/user/user.selector.js';
import { setDisplayedGradient } from '../../store/system/system.action.js';

// components
import CylinderCardBackground from '../../components/cylinder-card-background/CylinderCardBackground.js';
import LandingDescription from './components/landing-description/LandingDescription.js';
import GroupCodeLookup from './components/group-code-lookup/GroupCodeLookup.js';
import GradientBG from '../../components/gradient-bg/GradientBG.js';
import PrimaryBtn from '../../components/btns/primary-btn/PrimaryBtn.js';
import PageNav from '../../components/system/page-nav/PageNav.js';

// assets
import DiscordIcon from '../../assets/landing/discord-icon.png';

// styles
import {
    LandingPageContainer,
    LandingContent,
    Hero,
    CTAButtons,
    DiscordBtn,
    MainGradientBGContainer
} from './LandingPage.styles.js';

export default function LandingPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const displayedGradient = useSelector(selectDisplayedGradient);
    const teamIndex = useSelector(selectTeamIndex);
    const gradientData = useSelector(selectGradientData);
    const user = useSelector(selectUser);
    const emailVerificationPending = useSelector(selectEmailVerificationPending);

    useEffect(() => {
        if (!displayedGradient) {
            dispatch(setDisplayedGradient('A'));
        }
    }, [dispatch, displayedGradient]);

    // Redirect to auth if user needs to verify email
    useEffect(() => {
        if (user && emailVerificationPending) {
            navigate('/auth', { replace: true });
        }
    }, [user, emailVerificationPending, navigate]);

    const handleSignIn = () => {
        navigate('/auth', { state: { tab: 'signIn' } });
    };

    const handleJoinDiscord = () => {
        window.open('https://discord.gg/eNquwMMbRk', '_blank', 'noopener,noreferrer');
    };

    return (
        <LandingPageContainer>
            <PageNav />
            <LandingContent>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <Hero>
                        <h1><span style={{ opacity: 0.66 }}>Your collection,</span> organized</h1>
                        <CTAButtons>
                            <PrimaryBtn
                                title="SIGN IN"
                                onClick={handleSignIn}
                            />
                            <DiscordBtn onClick={handleJoinDiscord}>
                                <img src={DiscordIcon} alt="Discord" />
                                JOIN DISCORD
                            </DiscordBtn>
                        </CTAButtons>
                    </Hero>
                    <GroupCodeLookup />
                </div>
                <LandingDescription />
            </LandingContent>
            <CylinderCardBackground
                numColumns={8}
                cardsPerColumn={8}
                radius={600}
                arcDegrees={180}
                speed={24}
                opacity={0.55}
            />
            <MainGradientBGContainer>
                <GradientBG setGradient={gradientData[teamIndex] ?? gradientData[0]} />
            </MainGradientBGContainer>
        </LandingPageContainer>
    );
}
